import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { RoomType } from '../../models'
import { RoomTypeService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'

const log = new Logger('RoomTypeDetailResolver')
@Injectable({ providedIn: 'root' })
export class RoomTypeDetailResolver implements Resolve<Observable<RoomType>> {
  constructor(private roomService: RoomTypeService, private router: Router) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['rid']
    
    return this.roomService.getRoomTypeDetail(rid).pipe(
      map(data => {
        log.debug('RoomTypeDetailResolver Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/roomtypes']))
    )
  }
}
